module.exports = __webpack_public_path__ + "static/img/home_zjgx_pic2.a63c81f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_zjgx_pic2.png
// module id = KcUH
// module chunks = 0